<template>
  <div class="MyButton" :style="{ width: `${width}px`, height: `${height}px` }">
    <svg :height="height" :width="width">
      <!-- 定义线性渐变 -->
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="50%">
        <stop offset="0%" stop-color="#3881f8" />
        <stop offset="100%" stop-color="#5da1fe" />
      </linearGradient>
      <!-- 使用多边形元素绘制六边形 -->
      <polygon :points="points" fill="url(#gradient)" />
    </svg>
    <div class="content"><slot></slot></div>
  </div>
</template>

<script>
import Title from "@/views/home/components/Title.vue";
export default {
  props: {},
  components: {
    Title,
  },
  data() {
    return {
      width: 180,
      height: 66,
      radius: 12,
    };
  },
  computed: {
    points() {
      return `0,${this.radius} ${this.radius},0 ${this.width},0 ${this.width},${
        this.height - this.radius
      } ${this.width - this.radius},${this.height} 0,${this.height}`;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  watch: {
    isMobile: {
      immediate: true,
      handler(val) {
        if (val) {
          this.width = 100;
          this.height = 40;
          this.radius = 8;
        } else {
          this.width = 180;
          this.height = 66;
          this.radius = 12;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "@/assets/styles/variables.scss"; // global css
.MyButton {
  width: 180px;
  height: 66px;
  // background: linear-gradient(90deg, #3881f8 0%, #5da1fe 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 22px;
  color: #ffffff;
  position: relative;
  cursor: pointer;
  &:hover {
    transform: scale(1.04);
  }
  svg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content {
    position: relative;
  }
}
.isMobile {
  .MyButton {
    font-size: 14px;
  }
}
</style>
